/**
 * Risalet-in Nur kütüphanesindeki metinler — program akışına bağlanmak
 * için.
 *
 * Kitaplar Envâr Neşriyat 2005 baskısı; kütüphanede yayında olan takım
 * budur. Adresler kütüphanenin okuyucu yolu: /#/oku/<kitap>.
 *
 * Liste elle tutuluyor: on beş kitap yıllardır aynı, uzaktan çekmek için
 * bir istek daha yapmaya değmez.
 */
const KOK = 'https://risaletinnur.com/#/oku';

export interface KulliyatEseri {
  ad: string;
  yol: string;
}

/** Kur'an ve evrad — "Kur'an okuma" satırları için. */
export const KURAN: KulliyatEseri[] = [
  { ad: "Kur'an-ı Kerim", yol: `${KOK}/kuran` },
  { ad: "Mealli Kur'an", yol: `${KOK}/kuranmeal` },
  { ad: 'Cevşen', yol: `${KOK}/cevsen` },
  { ad: 'Tesbihat', yol: `${KOK}/tesbihat` },
];

/** Envâr Neşriyat 2005 — Büyük Boy Eserler. */
export const KULLIYAT: KulliyatEseri[] = [
  { ad: 'Sözler', yol: `${KOK}/sozler` },
  { ad: 'Mektubat', yol: `${KOK}/mektubat` },
  { ad: "Lem'alar", yol: `${KOK}/lemalar` },
  { ad: 'Şualar', yol: `${KOK}/sualar` },
  { ad: 'Mesnevi-i Nuriye', yol: `${KOK}/mesnevi` },
  { ad: "İşârât-ül İ'caz", yol: `${KOK}/isarat` },
  { ad: 'Barla Lâhikası', yol: `${KOK}/barla` },
  { ad: 'Kastamonu Lâhikası', yol: `${KOK}/kastamonu` },
  { ad: 'Emirdağ Lâhikası 1', yol: `${KOK}/emirdag1` },
  { ad: 'Emirdağ Lâhikası 2', yol: `${KOK}/emirdag2` },
  { ad: 'Sikke-i Tasdik-i Gaybî', yol: `${KOK}/stgayb` },
  { ad: 'Tarihçe-i Hayat', yol: `${KOK}/tarihce` },
  { ad: 'Asâ-yı Mûsa', yol: `${KOK}/asamusa` },
  { ad: 'İman ve Küfür Muvazeneleri', yol: `${KOK}/imankufur` },
  { ad: 'Muhâkemat', yol: `${KOK}/muhakemat` },
];

/** Kur'an okuma satırının öntanımlı bağlantısı. */
export const KURAN_YOLU = KURAN[0].yol;

/** Bağlantının hangi esere gittiği — satırda adıyla görünsün diye. */
export function eserAdi(yol?: string): string | undefined {
  if (!yol) return undefined;
  return [...KURAN, ...KULLIYAT].find((e) => e.yol === yol)?.ad;
}
